import { createSlice, SliceCaseReducers, PayloadAction } from "@reduxjs/toolkit";
import {
  ISchemaAdminInfo,
  IBusinessInfo,
  ISchemaBusinessSubAndPayment,
} from "../../shared/types";
import { RootState } from "../store";

interface IUserRegistrationState {
  admin_info: Partial<ISchemaAdminInfo>;
  business_info: Partial<IBusinessInfo>;
  currentPage: number;
}

const registrationSlice = createSlice<
  IUserRegistrationState,
  SliceCaseReducers<IUserRegistrationState>
>({
  name: "registration",
  initialState: {
    admin_info: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
    },
    business_info: {},
    currentPage: 0,
  },
  reducers: {
    setAdminInfo: (state, action:PayloadAction<ISchemaAdminInfo>) => {
      state.admin_info = action.payload;
    },
    setBusinessInfo: (state, action:PayloadAction<IBusinessInfo>) => {
      state.business_info = action.payload;
    },
    setCurrentPage: (state, action:PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setPaymentInfo: (state, action:PayloadAction<ISchemaBusinessSubAndPayment>) => {
      state.business_info.sub_and_payment = action.payload;
    },
    resetRegistration: (state) => {
      state.admin_info = {};
      state.business_info = {};
      state.currentPage = 0;
    },
  },
});

export const registrationSliceActions = registrationSlice.actions;
export const selectAdminInfo = (state: RootState) =>
  state.registration.admin_info;
export const selectBusinessInfo = (state: RootState) =>
  state.registration.business_info;
export const selectCurrentPage = (state: RootState) =>
  state.registration.currentPage;
export default registrationSlice.reducer;
